var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 40.25H50.75L45.5 50.75L38.5 29.75L33.25 40.25H29.75M41.976 17.9753C34.9783 9.7944 23.3091 7.59375 14.5414 15.085C5.77375 22.5763 4.53939 35.1014 11.4247 43.9614C16.6253 50.6535 31.3995 64.0883 38.318 70.2621C39.5898 71.397 40.2258 71.9645 40.9704 72.1878C41.6168 72.3817 42.3352 72.3817 42.9817 72.1878C43.7263 71.9645 44.3622 71.397 45.634 70.2621C52.5525 64.0883 67.3267 50.6535 72.5274 43.9614C79.4127 35.1014 78.329 22.4975 69.4106 15.085C60.4922 7.67255 48.9738 9.7944 41.976 17.9753Z",
    stroke: "#FEFEFE",
    strokeWidth: 4.34483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitals);
export default __webpack_public_path__ + "static/media/vitals.4abf261fbd66e0afe71c882c8a19c19c.svg";
export { ForwardRef as ReactComponent };